import { Component, Input } from '@angular/core';
import { PurchaseOrderManagerService } from 'src/app/services/purchase-order/purchase-order-manager.service';
import { PurchaseOrderPDFComponent } from '../../../purchase-order-pdf/purchase-order-pdf.component';
import { Contact } from 'src/app/services/vendor/contact.model';

@Component({
  selector: 'ls-vehicle-info',
  templateUrl: './vehicle-info.component.html',
  styleUrl: './vehicle-info.component.less'
})
export class VehicleInfoComponent {
  @Input() makeOptional: boolean = true
  @Input() modelOptional: boolean = true
  @Input() colorOptional: boolean = true
  @Input() numberOptional: boolean = true
  @Input() stateOptional: boolean = true
  @Input() numberStateVisible: boolean = true

  _selectedContact: Contact = null;
  get selectedContact() {
    return this._selectedContact;
  }
  @Input() set selectedContact(value: Contact) {
    this._selectedContact = value;
    if(value == null)
      return;
    this.poManager.current.vehicleMake = value.vehicleMake;
    this.poManager.current.vehicleModel = value.vehicleModel;
    this.poManager.current.vehicleColor = value.vehicleColor;
    this.poManager.current.vehicleNumber = value.vehicleNumber;
    this.poManager.current.vehicleState = value.vehicleState;
  }

  VI = VehicleInfoComponent

  private static poManagerStatic: PurchaseOrderManagerService;
  static title: string = 'Vehicle info:';
  static makeText: string = 'Make _________________________';
  static modelText: string = 'Model _________________________';
  static colorText: string = 'Color _________________________';
  static numberText: string = 'Registration # _______________________________________________';
  static stateText: string = 'State ______________';

  constructor(public poManager: PurchaseOrderManagerService) { 
    VehicleInfoComponent.poManagerStatic = this.poManager;
  }

  static removeUnderscores(text: string): string {
    return text.replace(/_/g, '');
  }

  static addToPdf(parent: PurchaseOrderPDFComponent, poManager?: PurchaseOrderManagerService) {
    if(poManager)
      VehicleInfoComponent.poManagerStatic = poManager;
    
    parent.outputText(this.title);
    parent.result.bottomOfOutput += parent.lineHeight;
    parent.outputText(`${this.makeText} ${this.modelText} ${this.colorText}`)
    if(this.poManagerStatic.current.vehicleMake?.length > 0)
      parent.outputText(this.poManagerStatic.current.vehicleMake, parent.textWidth(this.removeUnderscores(this.makeText)) + 1);
    
    if(this.poManagerStatic.current.vehicleModel?.length > 0)
      parent.outputText(this.poManagerStatic.current.vehicleModel, parent.textWidth(`${this.makeText} ${this.removeUnderscores(this.modelText)}`) + 1);
    
    if(this.poManagerStatic.current.vehicleColor?.length > 0)
      parent.outputText(this.poManagerStatic.current.vehicleColor, parent.textWidth(`${this.makeText} ${this.modelText} ${this.removeUnderscores(this.colorText)}`) + 2);

    parent.result.bottomOfOutput += parent.lineHeight;

    parent.outputText(`${this.stateText} ${this.numberText}`)
    if(this.poManagerStatic.current.vehicleState?.length > 0)
      parent.outputText(this.poManagerStatic.current.vehicleState, parent.textWidth(this.removeUnderscores(this.stateText)) + 1);
    
    if(this.poManagerStatic.current.vehicleNumber?.length > 0)
      parent.outputText(this.poManagerStatic.current.vehicleNumber, parent.textWidth(`${this.stateText} ${this.removeUnderscores(this.numberText)}`) + 1);
  }

  static clearInfo() {
    this.poManagerStatic.current.vehicleMake = '';
    this.poManagerStatic.current.vehicleModel = '';
    this.poManagerStatic.current.vehicleColor = '';
    this.poManagerStatic.current.vehicleNumber = '';
    this.poManagerStatic.current.vehicleState = '';
  }
}
